const elementResizeDetectorMaker = require('element-resize-detector')
const erdUltraFast = elementResizeDetectorMaker({
  strategy: 'scroll', // <- For ultra performance.
})

// this occurs once when the directive is attached to the element.
function bind(el, binding, vnode) {
  let options = {}
  if (binding.value) {
    options = binding.value
  }
  erdUltraFast.listenTo(options, el, element => {
    const width = element.offsetWidth
    const height = element.offsetHeight
    if (vnode.componentInstance) {
      vnode.componentInstance.$emit('resize', { detail: { width, height } })
    } else {
      vnode.elm.dispatchEvent(
        new CustomEvent('resize', { detail: { width, height } }),
      )
    }
  })
}

function unbind(el) {
  erdUltraFast.uninstall(el)
}

export default {
  bind,
  unbind,
}
